import { Axios } from '@utils/api/axios-instance';
import { useMutation, UseMutationResult } from 'react-query';
import { TokenExtension } from '@utils/extensions/token.extension';

interface CreateAlignmentSessionPayload {
  language: string;
  folder_id?: number | null;
}

interface AlignmentSessionResponse {
  result: {
    session_id: string;
    status: string;
    status_code?: number;
    session_mode?: string;
    language?: string;
    date_create?: string;
  };
}

const createAlignmentSession = async (
  payload: CreateAlignmentSessionPayload
): Promise<AlignmentSessionResponse> => {
  const authToken = TokenExtension.get();

  const response = await Axios.post<AlignmentSessionResponse>(
    '/api/v3/speech-to-text/session',
    {
      language: payload.language,
      session_mode: 'align',
      folder_id: payload.folder_id
    },
    {
      headers: {
        Authorization: `Bearer ${authToken.string}`
      }
    }
  );

  return response.data;
};

export const useCreateAlignmentSession = (): UseMutationResult<
  AlignmentSessionResponse,
  Error,
  CreateAlignmentSessionPayload
> => {
  return useMutation(createAlignmentSession);
};
